import React from 'react';
import ReactDOM from 'react-dom';

import {Cart} from './components';

export default (function () {
  const rootUrl = window.theme.locale && !window.theme.locale.primary ? window.theme.locale.rootUrl : '';

  const cartPageWrapper = document.querySelector('#react-cart-page');
  if (cartPageWrapper && window.theme.locale.pageType === 'cart') {
    ReactDOM.render(<Cart rootUrl={rootUrl} isCartPage />, cartPageWrapper);
  }
})();
